import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

export interface Params {
  bookingId: string;
  startDate: string;
  endDate: string;
}

interface RequestOptions extends Options {
  signal?: AbortSignal;
}

const getAvailabilityForOffer = async (
  { bookingId, startDate, endDate }: Params,
  options: RequestOptions = {},
): Promise<SelfServiceAPI.GetAvailabilityForOffer.Response> => {
  try {
    const { data } = await api.get(`/availability/${bookingId}`, { params: { startDate, endDate }, signal: options.signal });
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: `GET /availability/${bookingId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getAvailabilityForOffer;
